export default function Deletemydata(){


    return(

        <div>
            <h1>How to delete your data</h1>
            <div>
            Data Deletion. At Client’s written request by email (editor@myjoyonline.com), myjoyonline.com shall either delete or return all the Client Personal Data to Client in such form as Client reasonably requests within a reasonable time after the end of the provision of the relevant services related to processing, and delete existing copies unless storage of any data is required by any applicable law.
            </div>
        </div>
    )
}